<template>
  <el-dialog
    :visible.sync="showArticle"
    width="45%"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="true"
    destroy-on-close
    title="发布现场"
    @closed="handleClose"
    :close-on-click-modal="false"
    class="article-edit"
  >
    <el-form ref="form1" label-position="top" :model="form"  :rules="rules">
      <el-form-item prop="content" label="内容">
        <el-input :rows="7" v-model="form.content" type="textarea" autocomplete="off" maxlength="500" placeholder="请输入内容"></el-input>
      </el-form-item>
      <el-form-item label="图片" style="display: flex;flex-direction: column" >
        <love-element-upload
          :list-type="uploadOption.option.listType"
          :drag="uploadOption.option.drag"
          :allow-type="uploadOption.option.allowType"
          :allow-size="uploadOption.option.allowSize"
          :disabled="uploadOption.option.disabled"
          :limit="uploadOption.option.limit"
          :multiple="uploadOption.option.multiple"
          :love-path="uploadOption.lovePath"
          :file-list="uploadOption.option.fileList.attachment"
          :accept="uploadOption.option.accept"
          :show-file-list="uploadOption.option.showFileList"
          :tips="uploadOption.option.tips"
          @preview="onPreviewAttachment"
          @remove="onRemoveAttachment"
          @success="onSuccessAttachment" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="medium" type="info" @click="handleClose">取消</el-button>
      <axj-button color="#00adb5" size="max" @click="handleSubmit">发布</axj-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "article-edit",
  data(){
    return{
      showArticle:false,
      uploadOption: {
        lovePath: {
          module: "extra/competition",
          source_directory: "", // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        option: {
          listType: "picture-card",
          drag: false,
          multiple: true,
          allowType: ["image/jpg", "image/jpeg", "image/png"],
          disabled: false,
          limit: 3,
          fileList: {
            attachment: [],
            remove:[],
          },
          allowSize: 4,
          accept: 'image/*',
          showFileList: true
        }
      },
      form:{
        content:""
      },
      rules: {
        content: [
          { required: true, message: '内容不能为空', trigger: 'change' }
        ],
      }
    }
  },
  methods:{
    handleOpen(){
      if(this.isEdit==1){
        this.handleGetArticle()
      }else if(this.isEdit==2){
        this.uploadOption=this.uploadOption2
        this.form=this.content
      }
    },
    handleUpdateArticle(){
      this.$api.axjExtracurricularApi.competitionClub.updateCompetitionArticle({
        id:this.articleId,
        ...this.form
      }).then(res=>{

      })
    },
    handleGetArticle(){
      this.$api.axjExtracurricularApi.competitionClub.getCompetitionArticle(this.articleId).then(res=>{
        this.form.content=res.data.content
        res.data.Thumbs.map(item=>{
          let attachment = {
            id: item.id,
            name: item.name,
            url:  this.$store.getters.getResourcePrefix.url+item.url,
            type: item.type
          }
          this.uploadOption.option.fileList.attachment.push(attachment)
        })
      })
    },
    handleClose(){
      this.uploadOption={
        lovePath: {
          module: "extra/competition",
          source_directory: "", // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        option: {
          listType: "picture-card",
          drag: false,
          multiple: true,
          allowType: ["image/jpg", "image/jpeg", "image/png"],
          disabled: false,
          limit: 3,
          fileList: {
            attachment: [],
            remove:[],
          },
          allowSize: 4,
          accept: 'image/*',
          showFileList: true
        }
      }
      this.$emit("update:show",false)
    },
    onPreviewAttachment(file) {
    },
    onRemoveAttachment(file, fileList) {
      // 若是有 id
      if(file.id){
        // 记录
        this.uploadOption.option.fileList.remove.push(file.id)
      }
      this.uploadOption.option.fileList.attachment = fileList.map(item => {
        if (typeof(item.response) != 'undefined') {
          return {
            uid: item.uid,
            name: item.response.old_name,
            url: item.response.url,
            status: item.status
          }
        }
        return item
      })
      console.log(file)
      console.log(fileList)
    },
    onSuccessAttachment(response) {
      // 保存返回值
      const file = {
        uid: response.uid,
        name: response.old_name,
        url: response.url,
        type: response.type,
        status: "success"
      }
      this.uploadOption.option.fileList.attachment[this.uploadOption.option.fileList.attachment.length] = file
    },
    handleSubmit(){
      this.$refs['form1'].validate(async (valid) => {
        if(valid){
          if(this.isEdit==0){
            //await this.handleCreateCompetitionArticle()
            this.$nextTick(()=> {
              this.$emit('created',this.form,this.uploadOption)
            })
          }else if(this.isEdit==1){
            this.handleUpdateArticle()
            this.deleteAttachment()
            this.handleUpdateCompetitionAttachment()
            this.$nextTick(()=> {
              this.$emit('updated',this.form,this.uploadOption)
            })
          }
        }
      })
    },
    handleUpdateCompetitionAttachment(){
      let uploadOption=this.uploadOption
      let id=this.articleId
      for(var i=0; i<uploadOption.option.fileList.attachment.length; i++) {
        // 若是没有 id，则创建，有的代表数据库中已有该文件
        if (!(uploadOption.option.fileList.attachment[i].id)) {
          let attachment = {
            article_id: id,
            type: uploadOption.option.fileList.attachment[i].type ? uploadOption.option.fileList.attachment[i].type : 'Unknown',
            name: uploadOption.option.fileList.attachment[i].name,
            user_id: this.$store.getters.getUser.infoUserUid,
            user_name: this.$store.getters.getUser.uname,
            user_avatar: this.$store.getters.getUser.avatar,
            status: 1,
            url: uploadOption.option.fileList.attachment[i].url.slice(this.$store.getters.getResourcePrefix.url.length)
          }
          this.$api.axjExtracurricularApi.competitionClub.createCompetitionArticleAttachments(attachment)
        }
      }
    },
    // handleCreateCompetitionArticle(){
    //   this.$api.axjExtracurricularApi.competitionClub.createCompetitionArticle({
    //     competition_id:this.competition_id,
    //     ...this.form
    //   }).then(res=>{
    //     console.log(res)
    //   })
    // },
    deleteAttachment() {
      for(var i=0; i<this.uploadOption.option.fileList.remove.length; i++) {
        console.log(this.uploadOption.option.fileList.remove[i])
        this.$api.axjExtracurricularApi.competitionClub.deleteCompetitionArticleAttachments(this.uploadOption.option.fileList.remove[i])
          .then(res=> {
            console.log("删除附件成功")
          })
          .catch(err=> {
            console.log("删除附件失败")
          })
      }
    }
    // this.$api.axjExtracurricularApi.competitionClub.createCompetitionFile
  },
  props:{
    isEdit:{
      type:Number,
      default:0
    },
    articleId:{
      type:Number,
      default:0
    },
    show:{
      type:Boolean,
      default:false
    },
    content:{
      type:String,
      default:undefined
    },
    uploadOption2:{
      type:Object,
      default:()=>{

      }
    }
  },
  watch:{
    show(v){
      this.showArticle=v
    }
  }
}
</script>

<style slot-scope lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/axj-extracurricular/axj-competition-club/action/component/article-edit.vue